/**
 * Loads the Google Maps JavaScript API once and returns a Promise that resolves
 * when `window.google.maps` is ready. Safe to call multiple times — subsequent
 * calls return the same promise.
 */
let _loadPromise = null;

export function loadGoogleMaps() {
  if (_loadPromise) return _loadPromise;

  _loadPromise = new Promise((resolve, reject) => {
    // Already loaded
    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!key) {
      reject(new Error('REACT_APP_GOOGLE_MAPS_API_KEY is not set'));
      return;
    }

    const callbackName = '__gmapsLoaded_' + Date.now();
    window[callbackName] = () => {
      delete window[callbackName];
      resolve(window.google.maps);
    };

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=en&region=TZ&callback=${callbackName}`;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      _loadPromise = null;
      reject(new Error('Failed to load Google Maps script'));
    };
    document.head.appendChild(script);
  });

  return _loadPromise;
}
